<template>
  <div>
    <base-page-heading title="Work Order Overtime Report" />
    <div class="content">
      <overtime-list-filter
        class="mb-0"
        :columns="columns"
        :initial-filters="filters"
        @filters-applied="applyFilters"
      />
      <overtime-table
        class="mt-3"
        :filters="filters"
        :columns="columns"
        v-bind="{ ...sorting, ...pagination }"
      />
    </div>
  </div>
</template>

<script>
import listMixin from '@/mixins/listMixin';
import { DateTime } from 'luxon';
import {
  WORK_ORDER_OVERTIME_DEFAULT_REGULAR_ENDS_AT,
  WORK_ORDER_OVERTIME_DEFAULT_REGULAR_STARTS_AT,
  WORK_ORDER_OVERTIME_REPORT_TABLE_NAME,
} from '@/constants/reports';
import OvertimeListFilter from '@/components/admin/reports/workOrders/OvertimeListFilter.vue';
import OvertimeTable from '@/components/admin/reports/workOrders/OvertimeTable.vue';

export default {
  name: 'WorkOrdersOvertimeReport',
  components: {
    OvertimeTable,
    OvertimeListFilter,
  },
  mixins: [listMixin],
  props: {
    client_ids: Array,
    location_id: String,
    service_id: String,
    checked_out_from: String,
    checked_out_to: String,
    assigned_to_id: String,
    statuses: Array,
    regular_starts_at: String,
    regular_ends_at: String,
    include_weekends: [String, Boolean],
  },
  data() {
    const defaultCheckedOutFrom = this.$options.filters.dateFormat(DateTime.now().minus({ month: 6 }).toISODate());
    const defaultCheckedOutTo = this.$options.filters.dateFormat(DateTime.now().toISODate());

    return {
      tableName: WORK_ORDER_OVERTIME_REPORT_TABLE_NAME,
      filters: {
        client_ids: this.client_ids,
        location_id: this.location_id,
        service_id: this.service_id,
        checked_out_from: this.checked_out_from || defaultCheckedOutFrom,
        checked_out_to: this.checked_out_to || defaultCheckedOutTo,
        assigned_to_id: this.assigned_to_id,
        statuses: this.statuses,
        regular_starts_at: this.regular_starts_at || WORK_ORDER_OVERTIME_DEFAULT_REGULAR_STARTS_AT,
        regular_ends_at: this.regular_ends_at || WORK_ORDER_OVERTIME_DEFAULT_REGULAR_ENDS_AT,
        include_weekends: this.include_weekends == null
          ? true
          : ['true', true].includes(this.include_weekends),
      },
    };
  },
};
</script>
